import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const SahCategoriesLookupState = (state: RootState) => state.lookups.sahCategories;

export const selectSahCategories = (state: RootState) => SahCategoriesLookupState(state).rows;
export const selectSahCategoriesLoading = (state: RootState) => SahCategoriesLookupState(state).loading;

export const selectSahCategoryById = createSelector(
  [selectSahCategories, (_: RootState, id?: string) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);

export const selectLookupSahCategories = createSelector(selectSahCategories, (rows) =>
  rows.map(({ id, name }) => ({ id, name })),
);
